import * as Roles from '../roles'

export const TAB_PERMISSIONS = {
  [Roles.SUPER_ADMIN]: {
    profile: true,
    contact_notes: true,
    events: true,
    deviceData: true,
    commsHistory: true,
    engBooking: true,
    leakFree: true,
    admin: true
  },
  [Roles.ADMIN]: {
    profile: true,
    contact_notes: true,
    events: true,
    deviceData: true,
    commsHistory: true,
    engBooking: true,
    leakFree: true,
    admin: true
  },
  [Roles.EXT_OPS]: {
    profile: true,
    contact_notes: true,
    events: true,
    deviceData: true,
    commsHistory: true,
    engBooking: true,
    leakFree: false,
    admin: false
  },
  [Roles.MAINTENANCE]: {
    profile: false,
    contact_notes: false,
    events: true,
    deviceData: false,
    commsHistory: true,
    engBooking: false,
    leakFree: false,
    admin: false
  },
  [Roles.INSURANCE]: {
    profile: false,
    contact_notes: false,
    events: true,
    deviceData: false,
    commsHistory: true,
    engBooking: false,
    leakFree: false,
    admin: false
  },
  [Roles.ANALYTICS]: {
    profile: false,
    contact_notes: false,
    events: false,
    deviceData: false,
    commsHistory: false,
    engBooking: false,
    leakFree: false,
    admin: false
  }
}
